/**
 * A conta do arrasto — e o motivo de ela nao usar `clientX`.
 *
 * A bolha vive num iframe, e quem move o iframe e o host. Entao existe uma
 * malha fechada: o widget mede o dedo, o host move o iframe, e a proxima medida
 * sai de um iframe que ACABOU DE SE MOVER.
 *
 * `clientX` e relativo ao viewport do iframe. Com o iframe perseguindo o dedo,
 * o dedo fica quase parado em relacao a ele — o delta medido encolhe, e o host,
 * que calcula a posicao absoluta a partir da origem, nunca alcanca. Medido: o
 * dedo andou 200px e a bolha andou 80. O atraso nao estabiliza, cresce.
 *
 * `screenX` e relativo a TELA, que nao se move. E o unico referencial estavel
 * disponivel dos dois lados da fronteira de origem.
 */

export type Point = { x: number; y: number }

/** So o que a conta precisa — deixa o teste chamar sem forjar um PointerEvent. */
export type ScreenPoint = { screenX: number; screenY: number }

/** Distancia minima antes de chamar de arrasto; abaixo disso, e clique. */
export const DRAG_THRESHOLD = 4

export function dragOrigin(event: ScreenPoint): Point {
  return { x: event.screenX, y: event.screenY }
}

export function dragDelta(origin: Point, event: ScreenPoint): Point {
  return { x: event.screenX - origin.x, y: event.screenY - origin.y }
}

/**
 * Ja andou o bastante para ser arrasto?
 *
 * Distancia de Manhattan de proposito: e mais barata que a euclidiana e, num
 * limiar de 4px, a diferenca entre as duas nao e perceptivel.
 */
export function passouDoLimiar(delta: Point, limiar = DRAG_THRESHOLD): boolean {
  return Math.abs(delta.x) + Math.abs(delta.y) >= limiar
}
